<template>
    <button @click.stop="$emit('event', 'click', data)"  class="block w-full px-4 py-2 text-base leading-5 text-left text-gray-400 hover:text-red-400 transition duration-150 ease-in-out">
        <font-awesome-icon :icon="['far', 'trash-can']"></font-awesome-icon>
    </button>
</template>

<script>

export default {
    name: "MessageDeliverableDeleteButton",
    emits: ['event'],
    components: {},
    props: {
        meta: {
            type: Object,
            default: () => {}
        },
        name: {
            type: String,
            default: ''
        },
        data: {
            type: Object,
            default: () => {}
        },
        click: {
            type: Function,
            default: () => {}
        }
    }
}
</script>

<style scoped>

</style>
